var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDummyFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 131,
    viewBox: "0 0 124 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 160,
    transform: "translate(-48.4844 -15.0391)",
    fill: "url(#pattern0_1174_8535)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1174_8535",
    patternContentUnits: "objectBoundingBox",
    width: 0.0527273,
    height: 0.0725
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1174_8535",
    transform: "scale(0.00527273 0.00725)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1174_8535",
    width: 10,
    height: 10,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAABtJREFUGBljYCACTJ8+/T9BZaOKGKgXBMDQBgAiVBupw3yftQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyFrame);
export default __webpack_public_path__ + "static/media/dummyFrame.a851b4f0877c1ae0323dd52e63951b3b.svg";
export { ForwardRef as ReactComponent };